module.exports = __webpack_public_path__ + "img/shehui1.5a63a0f5.png";